import { Injectable } from '@angular/core';
import { AuthService as StemexeAuthService, AuthType } from "./auth.stemexe.service";
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { environment } from '@environments/environment';
import { LocalEnum } from '@plannexe/shared/enums/localstorage';
import { Observable, shareReplay } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { setPlannexeDocumentApiBaseUrl } from '@plannexe/shared/common/common-functions';

@Injectable({
  providedIn: 'root'
})
export class PlannexeAppService {
  private logo = new BehaviorSubject<any>('https://plannexe.exceeders.com/assets/engaged-images/plannexe-logo.png');
  private baseUrl = new BehaviorSubject<any>(environment.plannexe.baseURL);
  private isLoggedIn = false;
  private stemexeRoles = new BehaviorSubject<any>([]);
  private addons = new BehaviorSubject<any>([]);

  constructor(
    private stemexeAuthService: StemexeAuthService,
    private http: HttpClient,
  ) {
    const local = localStorage.getItem(LocalEnum.isloggedin);
    this.isLoggedIn = local === 'true' ? true : false;
  }
  
  get getLogo(): any{
    return this.logo.asObservable();
  }
  get plannexeBaseUrl(): any{
    return this.baseUrl.getValue();
  }
  get getStemexeRoles(): any{
    return this.stemexeRoles.asObservable();
  }
  get getAddons(): any{
    return this.addons.asObservable();
  }
  get getAddonsAsValue(): any{
    return this.addons.getValue();
  }
  get simpleStrataAddon(): any{
    const addons = this.addons.getValue();
    return addons.find((a: any) => a.Type == AuthType.SimpleStrata);
  }
  setBaseUrl(s: any): any{
    setPlannexeDocumentApiBaseUrl(s);
    return this.baseUrl.next(s);
  }
  getAddonsAuth(): Observable<any>{
    return this.stemexeAuthService.getAddonsAuth(this.stemexeAuthService.idenediGroupId).pipe(shareReplay());
  }
  checkBaseUrl(): void {
    if (this.isLoggedIn){
      this.getAddonsAuth().subscribe({
        next: (addons: any) => {
          this.addons.next(addons);
          console.log('checkBaseUrl', this.baseUrl);
          const plannexeAddon = addons.find((a: any) => a.Type == AuthType.EngagementPro);
          if(plannexeAddon.BaseUrl){
            this.setBaseUrl(plannexeAddon.BaseUrl);
          }
        }
      });
    }
  }
  checkAppAppearance(): void {
    const root:any = document.querySelector(':root');
    // set css variable
    root.style.removeProperty('--primary-color');
    root.style.removeProperty('--primary-color-lighter');

    if (this.isLoggedIn){
      this.getAddonsAuth().subscribe({
        next: (addons: any) => {
          this.addons.next(addons);
          console.log('checkBaseUrl', this.baseUrl);
          const appAddon = addons.find(
            (a: any) => a.Type == AuthType.AppAppearance
          );
          if(appAddon){
            const THEMES_COLORS_MAP = {
              1: ["#6cb33f", "#a0da6c"],
              2: ["#008657", "#01a888"],
              3: ["#f26648", "#f26648"],
              4: ["#111E6C", "#e21b24"],
              5: ["#f8971d", "#f8971d"],
              6: ["#00aeef", "#00aeef"],
              7: ["#3A7ABE", "#367dff"],
              8: ["#6666cc", "#6666cc"],
              9: ["#525f81", "#525f81"],
              10: ["#303030", "#303030"],
              11: ["#b68a35", "rgba(182, 138, 53, 0.6)"],
              12: ["#91C740", "#91C740"],
            };
            const themecolor = appAddon.PublicProperties.organziationId;
            if(themecolor){
              let theme = THEMES_COLORS_MAP[themecolor];
              console.log('THEMES_COLORS_MAP', theme);
              if(!theme){
                theme = ["#6cb33f", "#a0da6c"];
              }
              
              const root:any = document.querySelector(':root');
              // set css variable
              root.style.setProperty('--primary-color', theme[0]);
              root.style.setProperty('--primary-color-lighter', theme[1]);
            }
            if(appAddon.PublicProperties.logoUrl){
              this.logo.next(appAddon.PublicProperties.logoUrl);
            }
          }
        }
      });
    }
  }
  stemexeRoleList(lang: any = 'en'): any {
    this.http.get(this.plannexeBaseUrl + '/api/Role/GetSystemRoles').pipe(shareReplay()).subscribe((results: any) => {
      const roles = results.result.map((r: any) => {
        return {
          roleKey: r.roleKey,
          languageCode: lang,
          roleTitle: lang == 'ar' ? r.roleTitleAr : r.roleTitleEn,
          roleDescription: lang == 'ar' ? r.descriptionAr : r.description,
          extraData: ''
        };
      });
      this.stemexeRoles.next(roles);
      return roles;
    });
  }
}
